/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * OldPhoneIcon
 */
export default class OldPhoneIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M1.556 16.642c.164-.284.35-.55.558-.798.236-.28.513-.574.832-.881a3 3 0 014.001-.144l.353.294a1 1 0 001.324-.038c1.262-1.181 2.299-2.256 3.109-3.22a76.801 76.801 0 002.384-3.002.713.713 0 00-.173-1.024l-.17-.113a3 3 0 01-1.026-3.822c.29-.588.617-1.102.985-1.54.305-.364.622-.7.95-1.01a3 3 0 013.43-.485c3.143 1.615 4.54 3.605 3.788 5.892.085-.258-.226.697-.324.985-.162.478-.328.932-.514 1.398-.716 1.794-1.61 3.456-2.77 4.971-3.536 4.613-8.009 8.37-10.83 8.63-1.83.169-3.646-.685-5.43-2.468a3 3 0 01-.477-3.625zm1.73 1.001a1 1 0 00.16 1.209c1.4 1.4 2.674 1.998 3.834 1.891 2.08-.191 6.212-3.663 9.425-7.854 1.039-1.356 1.847-2.86 2.5-4.497.172-.43.327-.853.479-1.3.093-.274.398-1.21.317-.965.372-1.13-.428-2.269-2.803-3.49a1 1 0 00-1.143.162 9.876 9.876 0 00-.79.84c-.26.31-.502.689-.723 1.14a1 1 0 00.342 1.273l.17.113a2.713 2.713 0 01.657 3.895 78.787 78.787 0 01-2.446 3.08c-.866 1.031-1.957 2.162-3.275 3.395a3 3 0 01-3.97.115l-.353-.294a1 1 0 00-1.334.047c-.27.26-.5.503-.687.727-.134.159-.253.33-.36.513z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

